const Footer = () => {
  return (
    <>
      <footer className="mt-16 mb-8 ">
        <div className="content-center align-center justify-center justify-items-center">
          <p className="content-center align-center justify-center justify-items-center text-center">✨ Made with ❤️ by Picognition ✨</p>
        </div>
      </footer>
    </>
  );
};
export default Footer;
